module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("From Lagos to London")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#disclaimer"
    }
  }, [_vm._v("Disclaimer")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#foreword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#introduction",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-1-a-cold-welcome-arriving-in-the-uk",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1: A Cold\n                Welcome: Arriving in the UK")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#determined-to-be-different-pursuing-a-dream",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Determined To\n                        Be Different: Pursuing a Dream")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#life-lessons",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life Lessons")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-2-nurturing-a-generation-of-achievers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Nurturing\n                a Generation of Achievers")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#emilias-inspirational-wisdom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emilia’s Inspirational\n                        Wisdom")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#turning-dreams-into-reality",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turning Dreams into\n                        Reality")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#life-lessons-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life Lessons")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-3-the-journey-begins-from-independence-to-entrepreneurship",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: The\n                Journey Begins: From Independence to Entrepreneurship")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-initial-steps",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Initial Steps")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#planning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Planning")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#change-of-use",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Change of Use")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#life-lessons-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life Lessons")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-4-from-care-support-worker-to-care-home-owner-turning-dreams-into-reality",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter\n                4: From Care Support Worker to Care Home Owner: Turning Dreams into Reality")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#quick-takeaways",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Takeaways")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#tips-for-securing-residential-home-supported-living-accommodation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tips\n                        for Securing Residential Home/ Supported Living Accommodation")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-5-closure-of-the-residential-home-business-transition-into-real-estate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter\n                5: Closure of the Residential Home Business: Transition into Real Estate")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#moving-into-real-estate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moving into Real Estate")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#the-challenge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Challenge")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#premature-gratification",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Premature Gratification")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#building-generational-wealth-through-real-estate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Building\n                        Generational Wealth Through Real Estate")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#life-lessons-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life Lessons")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-6-fundamental-business-principles-ignorance-is-not-bliss",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6:\n                Fundamental Business Principles: Ignorance Is Not Bliss")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#life-lessons-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life Lessons")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-7-navigating-financial-turbulence-the-beginning-of-my-property-investment-journey",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter\n                7: Navigating Financial Turbulence: The Beginning of My Property Investment Journey")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-8-the-high-cost-of-ambition-balancing-health-wealth-and-well-being",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter\n                8: The High Cost of Ambition: Balancing Health, Wealth, and Well-Being")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#life-lessons-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life Lessons")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-9-from-breakdown-to-breakthrough-unleashing-your-inner-warrior",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9:\n                From Breakdown to Breakthrough: Unleashing Your Inner Warrior")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#life-lessons-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life Lessons")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#further-life-lessons",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Life Lessons")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-10-closing-thoughts-life-beyond-expectations-inspiring-others",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10:\n                Closing Thoughts Life Beyond Expectations: Inspiring Others")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0